// src/components/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center p-6">
            <motion.div
                className="max-w-md mx-auto"
                initial="hidden"
                animate="visible"
                variants={containerVariants}
            >
                <motion.h1
                    className="text-9xl font-extrabold text-indigo-600 mb-2"
                    variants={itemVariants}
                >
                    404
                </motion.h1>
                <motion.h2
                    className="text-3xl font-bold text-gray-800 mb-4"
                    variants={itemVariants}
                >
                    Halaman Tidak Ditemukan
                </motion.h2>
                <motion.p
                    className="text-gray-600 mb-8 max-w-sm mx-auto"
                    variants={itemVariants}
                >
                    Maaf, kami tidak dapat menemukan halaman yang Anda cari. Mungkin halaman tersebut telah dihapus, namanya diganti, atau tidak pernah ada.
                </motion.p>
                <motion.div variants={itemVariants}>
                    <Link
                        to="/"
                        className="inline-block bg-indigo-600 text-white font-bold px-8 py-4 rounded-full shadow-lg hover:bg-indigo-700 transition-all duration-300 transform hover:scale-105"
                    >
                        Kembali ke Beranda
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default NotFound;